module.exports = __webpack_public_path__ + "76a322f112a7c4630f54ff7a18b86231.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IQ.svg
// module id = nK93
// module chunks = 0